import comingSoon from "./coming-soon.json";
import notFound from "./not-found.json";
export { comingSoon, notFound };
